import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AnalysisStatus } from '../../interface/analysis';
import { Queue } from '../../interface/queue';

@Injectable({ providedIn: 'root' })
export class QueueService {
  private url = environment.url;

  constructor(private http: HttpClient) {}

  getQueueInfo(): Observable<Queue> {
    return this.http.get<any>(`${this.url}/queue`);
  }

  getAnalysisStatus(id: string): Observable<AnalysisStatus> {
    return this.http.get<any>(`${this.url}/analysis/status/${id}`);
  }
}
